<template>
  <div id="app">
    <keep-alive :exclude="excludeRoutes">
      <router-view></router-view>
    </keep-alive>
  </div>
</template>

<script>
import { getUrlParams } from "@/utils/url";
import { http } from "@/api/http";
export default {
  name: "App",
  components: {},
  computed: {
    excludeRoutes({ $store }) {
      return $store.state.keeps.routesName;
    },
  },
  created() {
    try {
      let { mtBmUid, gysCode, oIndex, channel, activityId, openId, pageId, productId, empId} = getUrlParams(
        window.location.href
      );
      console.log("gysCode =>", gysCode);
      console.log("activityId =>", activityId);
      console.log("openId =>", openId);


      let urlParams = getUrlParams(window.location.href);
      //将urlParm转果json字符串
      let urlParamsJson = JSON.stringify(urlParams);
      let params = {
        mtBmUid: openId,
        spiId: activityId,
        clickName: "HOME",
        uid: "",
        pageId: pageId,
        param: urlParamsJson
      };
      http("simViewLogAdd", params);


      if ((activityId || pageId || gysCode) && location.hash.indexOf("handing") == -1) {
        if (activityId) {
          mtBmUid = openId;
          //如果channel为空，则设置为ELM
          if (!channel) {
            channel = "ELM";
          }
          //广东联通
          if (activityId == "101000") {
            gysCode = "gzuni0000000001";
            oIndex = 0;
            this.$router.push({
              name: "GuangzhouUnicom1",
            });
          } else if (activityId == "101001" || activityId == "101002") {
            gysCode = "gzuni0000000001";
            oIndex = 1;
            this.$router.push({
              name: "GuangzhouUnicom2",
            });
          }
          else if (activityId == "101003") {
            gysCode = "gzuni0000000001";
            oIndex = 3;
            this.$router.push({
              name: "GuangzhouUnicom4",
            });
          } else if (activityId == "101004") {
            gysCode = "gzuni0000000001";
            oIndex = 4;
            this.$router.push({
              name: "BeautifulNumber",
            });
          } else if (activityId == "101005") {
            gysCode = "gzuni0000000001";
            oIndex = 5;
            this.$router.push({
              name: "GuangzhouUnicom5",
            });
          } else if (activityId == "101006") {
            gysCode = "gzuni0000000001";
            oIndex = 6;
            this.$router.push({
              name: "GuangzhouUnicom6",
            });
          } //陕西联通
          else if (activityId == "102001") {
            gysCode = "shanxi-uni-01";
            oIndex = "SXLT-QSZSK59";
            this.$router.push({
              name: "XianUnicom1",
            });
          }
          //北京联通
          else if (activityId == "103001") {
            gysCode = "beijing-uni-01";
            oIndex = "BJLT-QSK39";
            this.$router.push({
              name: "BeijingUnicom01",
            });
          }
          //佛山联通
          else if (activityId == "104001") {
            gysCode = "foshan-uni-01";
            oIndex = "FSLT-ELM01";
            this.$router.push({
              name: "FoshanUnicomElm01",
            });
          }
          //深圳联通
          else if (activityId == "105001") {
            gysCode = "shenzhen-uni-01";
            oIndex = "SZLT-01";
            this.$router.push({
              name: "ShenzhenUnicom01",
            });
          }
          else if (activityId == "401001") {
            gysCode = "guangzhou-uni-01";
            oIndex = 1;
            this.$router.push({
              name: "GuangzhouUnicom21",
            });
          }
          //广州电信
          else if (activityId == "201001") {
            gysCode = "guangzhou-telecom-01";
            oIndex = "GZDX-XXSL39";
            this.$router.push({
              name: "GuangzhouTelecom2",
            });
          }
          //浙江电信
          else if (activityId == "202001") {
            gysCode = "zhejiang-telecom-01";
            oIndex = "ZJDX-ELM29";
            this.$router.push({
              name: "ZhejiangTelecom1",
            });
          } 
          else if (activityId == "202002") {
            gysCode = "zhejiang-telecom-01";
            oIndex = "ZJDX-ELM49";
            this.$router.push({
              name: "ZhejiangTelecom2",
            });
          } 
          //天津电信
          else if (activityId == "203001") {
            gysCode = "tianjin-telecom-01";
            oIndex = "TJDX-ELM49";
            this.$router.push({
              name: "TianjinTelecom1"
            });
          }
          //广东移动
          else if (activityId == "301001") {
            // gysCode = "guangdong-mobile-01";
            // oIndex = "GDYD-ELM39";
            // this.$router.push({
            //   name: "GuangdongMobileElm39",
            // });
            gysCode = "guangzhou-mobile-01";
            oIndex = "GZYD-ELM02";
            this.$router.push({
              name: "GuangzhouMobileElm02",
            });
          }
          //广州移动
          else if (activityId == "302001") {
            gysCode = "guangzhou-mobile-01";
            oIndex = "GZYD-ELM39";
            this.$router.push({
              name: "GuangzhouMobileElm39",
            });
          }
          //深圳移动
          else if (activityId == "303001") {
            gysCode = "shenzhen-mobile-01";
            oIndex = "SZYD-ELM39";
            this.$router.push({
              name: "ShenzhenMobileElm39",
            });
          }
          //上海移动
          else if (activityId == "304001") {
            gysCode = "shanghai-mobile-01";
            oIndex = "SHYD-ELM39";
            this.$router.push({
              name: "ShanghaiMobileElm39",
            });
          }
          //湖北移动
         // else if (activityId == "306001") {
         //    gysCode = "hubei-mobile-01";
         //    oIndex = "HBYD-ELM01";
         //    this.$router.push({
         //      name: "HubeiMobileElm01",
         //    });
         //  }
          //佛山移动
          else if (activityId == "305001") {
            gysCode = "foshan-mobile-01";
            oIndex = "FSYD-ELM39";
            this.$router.push({
              name: "FoshanMobileElm39",
            });
          }
          //江苏移动
          else if (activityId == "307001") {
            gysCode = "jiangsu-mobile-01";
            oIndex = "JSYD-ELM01";
            this.$router.push({
              name: "JiangsuMobileElm01",
            });
          }
          //江苏移动2
          else if (activityId == "307002") {
            gysCode = "jiangsu-mobile-01";
            oIndex = "JSYD-ELM02";
            this.$router.push({
              name: "JiangsuMobileElm02",
            });
          }
          //河南移动
          else if (activityId == "308001") {
            gysCode = "henan-mobile-01";
            oIndex = "HNYD-ELM01";
            this.$router.push({
              name: "HenanMobileElm01",
            });
          }
          //东莞移动
          else if (activityId == "309001") {
            gysCode = "dongguan-mobile-01";
            oIndex = "DGYD-ELM39";
            this.$router.push({
              name: "DongguanMobileElm01",
            });
          }
          //京东渠道 start ===================
          //深圳联通
          else if (activityId == "JD105001") {
            gysCode = "shenzhen-uni-01";
            oIndex = "SZLT-QSK-JD38";
            channel = "JD";
            this.$router.push({
              name: "ShenzhenUnicomJd01",
            });
          }
          //深圳联通
          else if (activityId == "JD105002") {
            gysCode = "shenzhen-uni-01";
            oIndex = "SZLT-QSK-JD58";
            channel = "JD";
            this.$router.push({
              name: "ShenzhenUnicomJd02",
            });
          }
          //广州联通29元
          else if (activityId == "JD101001") {
            gysCode = "gzuni0000000001";
            oIndex = "GZLT-WQTC-JD29";
            channel = "JD";
            this.$router.push({
              name: "GuangzhouUnicomJd01",
            });
          }
          //广州联通38元
          else if (activityId == "JD101002") {
            gysCode = "gzuni0000000001";
            oIndex = "GZLT-QSK-JD38";
            channel = "JD";
            this.$router.push({
              name: "GuangzhouUnicomJd02",
            });
          }
          //广州电信（京东)
          else if (activityId == "JD201001") {
            gysCode = "guangzhou-telecom-01";
            channel = "JD";
            oIndex = "GZDX-XXSL39-JD";
            this.$router.push({
              name: "GuangzhouTelecomJd",
            });
          }
          //宁波电信（京东)
          else if (activityId == "JD204001") {
            gysCode = "ningbo-telecom-01";
            channel = "JD";
            oIndex = "NBDX-XXSL39-JD";
            this.$router.push({
              name: "NingboTelecomJd",
            });
          }
          //京东渠道 end ===================
          //金财客户端渠道 start ==============
          else if (activityId == "JCKHD110001") {
            gysCode = "shenzhen-uni-01";
            oIndex = "SZLT-QSK-JD38";
            channel = "JCKHD";
            this.$router.push({
              name: "GuangdongUnicomJC01",
            });
          }
          //深圳联通
          else if (activityId == "JCKHD105001") {
            gysCode = "shenzhen-uni-01";
            oIndex = "SZLT-QSK-JD38";
            channel = "JCKHD";
            this.$router.push({
              name: "ShenzhenUnicomJd01",
            });
          }
          //深圳联通
          else if (activityId == "JCKHD105002") {
            gysCode = "shenzhen-uni-01";
            oIndex = "SZLT-QSK-JD58";
            channel = "JCKHD";
            this.$router.push({
              name: "ShenzhenUnicomJd02",
            });
          }
          //广州联通29元
          else if (activityId == "JCKHD101001") {
            gysCode = "gzuni0000000001";
            oIndex = "GZLT-WQTC-JD29";
            channel = "JCKHD";
            this.$router.push({
              name: "GuangzhouUnicomJd01",
            });
          }
          //广州联通38元
          else if (activityId == "JCKHD101002") {
            gysCode = "gzuni0000000001";
            oIndex = "GZLT-QSK-JD38";
            channel = "JCKHD";
            this.$router.push({
              name: "GuangzhouUnicomJd02",
            });
          }
          //广州电信（京东)
          else if (activityId == "JCKHD201001") {
            gysCode = "guangzhou-telecom-01";
            channel = "JCKHD";
            oIndex = "GZDX-XXSL39-JD";
            this.$router.push({
              name: "GuangzhouTelecomJd",
            });
          }
          //宁波电信（京东)
          else if (activityId == "JCKHD204001") {
            gysCode = "ningbo-telecom-01";
            channel = "JCKHD";
            oIndex = "NBDX-XXSL39-JD";
            this.$router.push({
              name: "NingboTelecomJd",
            });
          }
          //饿了么骑手校验
          else if (activityId == "900001") {
            // 骑手单归属广州电信，补上 gysCode，否则订单列表页拿不到 spiId
            gysCode = "guangzhou-telecom-01";
            this.$router.push({
              name: "ElemeRiderCheck",
              query: {
                openId: openId || "",
              },
            });
          }
          //金财客户端渠道 end ============================
      } else if (pageId) {
        if (pageId == "GZDX00001") {
          this.$router.push({
            name: "GuangzhouTelecomAd",
          });
        } else if (pageId == "ZGDXKD") {
          this.$router.push({
            name: "zgdxkd",
          });
        }
      } else {
        if (gysCode == "gzuni0000000001") {
          let { saleId } = getUrlParams(window.location.href);
          localStorage.setItem("saleId", saleId);
          if (oIndex == 1) {
            this.$router.push({
              name: "GuangzhouUnicom2",
            });
          } else if (oIndex == 2) {
            this.$router.push({
              name: "GuangzhouUnicom3",
            });
            // this.$router.push({
            //   name: "notData",
            // });
            // this.$router.push({
            //   name: "GuangzhouUnicom5",
            // });
            // this.$router.push({
            //   name: "GuangzhouUnicom2",
            // });
          } else if (oIndex == 3) {
            this.$router.push({
              name: "GuangzhouUnicom4",
            });
            //   this.$router.push({
            //   name: "notData",
            // });
            // this.$router.push({
            //   name: "GuangzhouUnicom5",
            // });
            // this.$router.push({
            //   name: "GuangzhouUnicom2",
            // });
          } else if (oIndex == 4) {
            this.$router.push({
              name: "BeautifulNumber",
            });
          } else if (oIndex == 5) {
            this.$router.push({
              name: "GuangzhouUnicom5",
            });
          } else if (oIndex == 6) {
            this.$router.push({
              name: "GuangzhouUnicom6",
            });
          } else {
            this.$router.push({
              name: "GuangzhouUnicom1",
              // query: {
              //   spId,
              //   mtBmUid,
              //   oIndex
              // },
            });
          }
        } else if (gysCode == "shanxi-uni-01") {
          this.$router.push({
            name: "XianUnicom1",
          });
        } else if (gysCode == "gzdx0000000001") {
          this.$router.push({
            name: "GuangnzhouTelecom1",
          });
        } else if (gysCode == "xiamen-uni-01") {
          this.$router.push({
            name: "XiamenUnicom",
          });
        } else if (gysCode == "guangzhou-telecom-01") {
          this.$router.push({
            name: "GuangzhouTelecom2",
          });
        } else if (gysCode == "zhejiang-telecom-01") {
          if (oIndex == "ZJDX-ELM29") {
            this.$router.push({
              name: "ZhejiangTelecom1",
            });
          }else if (oIndex == "ZJDX-ELM49" || oIndex == "ZJDX-ELM59") {
            this.$router.push({
              name: "ZhejiangTelecom2",
            });
          }else{
            this.$router.push({
            name: "notData",
          });
          }
        } else if (gysCode == "guangdong-mobile-01") {
          if (oIndex == "GDYD-ELM39") {
            this.$router.push({
              name: "GuangdongMobileElm39",
            });
          } else{
            this.$router.push({
            name: "notData",
            });
          }
        }else {
          this.$router.push({
              name: "notData",
          });
        }
      }
    }
      localStorage.setItem("mtBmUid", mtBmUid);
      localStorage.setItem("gysCode", gysCode);
      localStorage.setItem("oIndex", oIndex);
      localStorage.setItem("channel", channel);
      localStorage.setItem("pageId", activityId);
      localStorage.setItem("productId", productId);
      localStorage.setItem("empId", empId);
    } catch (err) {
      console.log("err", err);
    }
  },
};
</script>

<style lang="scss">
#app {
  width: 100%;
  height: 100%;
  font-size: initial;
}
</style>
